//Show Newsletter Popup
setTimeout(function(){

  var x = localStorage.getItem("mytime");
console.log(x);
  if( x != 1 ){
  $('#newsletter').addClass('showpopup');
  localStorage.setItem("mytime", '1');
}
},1500);

//Close Newsletter Popup
$('.popup__close').click(function () {
  $('#newsletter').removeClass('showpopup');
})

$('.thumbnail-list-slider').slick({
slidesToShow: 5,
slidesToScroll: 1,
arrows: false,
dots: true,
vertical: true,
verticalSwiping: true
    
});

// (function () {
//   function checkInventory(productId, variantId) {
//     return fetch(`/products.json?ids=${productId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         const product = data.products.find(
//           (p) => String(p.id) === String(productId)
//         );
//         if (!product) return 0;
//         const variant = product.variants.find(
//           (v) => String(v.id) === String(variantId)
//         );
//         return variant ? variant.inventory_quantity : 0;
//       })
//       .catch(() => 0);
//   }

//   async function processWishlistButtons() {
//     const popup = document.querySelector(".sewp-engine-popup");

//     // If not found or already processed, do nothing
//     // if (!popup || popup.classList.contains("wishlist-found")) return;

//     // Mark as found so we don't re-process
//     popup.classList.add("wishlist-found");

//     const container = document.querySelector("#wishlist-page-contain");
//     if (!container) return;

//     const rows = container.querySelectorAll(
//       ".wh-grid-layout .wishlist-row .wishlist-column"
//     );
//     if (!rows.length) return;

//     for (const column of rows) {
//       const btn = column.querySelector("button.wishlist-cart");
//       if (!btn) continue;

//       const productId = btn.getAttribute("data-product_id");
//       const variantId = btn.getAttribute("data-variant_id");

//       if (!productId || !variantId) continue;

//       const inventory = await checkInventory(productId, variantId);

//       if (inventory <= 0) {
//         btn.textContent = "Sold out";
//         btn.classList.add("no-inventory");
//       }
//       // else inventory > 0, do nothing
//       // ✅ Always reset opacity after check

//     }
//     popup.classList.add("btn-found");
//   }

//   setInterval(processWishlistButtons, 100);
// })();
